import styled from "styled-components";
import { GenericButtonAtom, GenericButtonProps } from "./GenericButton";

export const SecondaryButtonAtom = styled(GenericButtonAtom)`
    width: 40px;
    height: 40px;
`

export interface SecondaryButtonProps extends GenericButtonProps {

}